const intervalFastChoices = [
  {
    name: 'day',
    data: {
      value: 1,
      unit: 'd',
    },
  },
  {
    name: 'few days',
    data: {
      value: 3,
      unit: 'd',
    },
  },
  {
    name: 'week',
    data: {
      value: 1,
      unit: 'w',
    },
  },
  {
    name: 'couple weeks',
    data: {
      value: 2,
      unit: 'w',
    },
  },
  {
    name: 'month',
    data: {
      value: 1,
      unit: 'm',
    },
  },
  {
    name: 'few months',
    data: {
      value: 3,
      unit: 'm',
    },
  },
  {
    name: 'year',
    data: {
      value: 1,
      unit: 'y',
    },
  },
  {
    name: 'couple years',
    data: {
      value: 2,
      unit: 'y',
    },
  },
]
export default intervalFastChoices



// WEBPACK FOOTER //
// ./src/views/misc/intervalFastChoices.js